<template lang="pug">
div
    v-dialog(v-model="isShowModal_" @close="isShowModal_=false" width="500")
        v-card
            v-card-title(class="elevation-1") 
                | Mantenedor {{nameModulo}}
                v-spacer
                v-btn(icon @click="isShowModal_=false")   
                    v-icon mdi-close
            v-container( fluid) 
                v-row
                    v-col( cols="12" md="12" sm="12" )
                        v-autocomplete(v-model="parameter.ColumnName" 
                                        :items="tablePending"
                                        item-text="ColumnName"
                                        item-value="ColumnName"
                                        label="Campos Formulario"
                                        placeholder="Campos Formulario"
                                        outlined
                                        hide-details="auto")       
                v-row
                    v-col( cols="12" md="12" sm="12" )
                        v-text-field(v-model="parameter.FieldName"
                                label="Titulo"
                                placeholder="Titulo"
                                outlined
                                hide-details="auto" 
                                )    
                v-row(v-if="parameter.ColumnName.indexOf('Select')>0")
                    v-col( cols="12" md="12" sm="12" )
                        v-autocomplete(v-model="parameter.IdDocListSelect" 
                                        :items="tableListSelect.filter(b=> b.BaseType==0)"
                                        item-text="Name"
                                        item-value="IdDocListSelect"
                                        label="Lista"
                                        placeholder="Lista"
                                        outlined
                                        hide-details="auto")                        
                v-row
                    v-col( cols="12" md="12" sm="12" )
                        label Validacion
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.IsValidated==2 ||  parameter.IsValidated==null ||  parameter.IsValidated==''", @click="parameter.IsValidated=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.IsValidated==1" ,@click="parameter.IsValidated=2" )   ON
                v-row(v-if="parameter.ColumnName.indexOf('TextBox')>0 && parameter.IsValidated==1 && tableListExpressionRegulate")
                    v-col( cols="12" md="12" sm="12" )
                        v-autocomplete(v-model="parameter.IdExpressionRegulate" 
                                        :items="tableListExpressionRegulate"
                                        item-text="Text"
                                        item-value="Value"
                                        label="Tipo Validacion"
                                        placeholder="Tipo Validacion"
                                        outlined
                                        hide-details="auto")       
        
            v-divider
            v-card-actions 
                v-spacer                    
                v-btn(color="primary" text @click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../../complementos/modal.vue"
import toolValidate from '../../../../tools/validate.js'
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object,
        tablePending:Array,
        tableListSelect:Array,
        tableListExpressionRegulate:Array
    },  
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)
                    this.$emit("sendInfo",this.parameter)
                }       
            },
            validate(){ 
                if(this.parameter.ColumnName=='' || this.parameter.ColumnName==null ){
                    this.$msgbox.show("Debe selecionar campo para Enlazar","Alerta")
                    return false
                } 
                else if(this.parameter.FieldName=='' || this.parameter.FieldName==null ){
                    this.$msgbox.show("Ingrese Titulo del Campo","Alerta")
                    return false
                }
                else if((this.parameter.IdDocListSelect=='' || this.parameter.IdDocListSelect==null ) && this.parameter.ColumnName.indexOf('Select')>0){
                    this.$msgbox.show("Selecione Lista","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>